import { useApiUrl } from "@refinedev/core";
import { DEFAULT_LIMIT } from "@src/components/intelligence-search/template-search";
import { useSmartCustomQuery } from "@src/hooks/use-smart-custom-query";
import { SmlAsset, JobMeta, SmlJsonQuery } from "src/types/intelligence-search";

export type LoadResponse = {
    data: Record<string, any>[];
    query: string;
    meta: JobMeta;
    cache_hit: boolean;
    schema: any[];
    ref_assets: SmlAsset[];
};

export const useLoad = ({
    jsonQuery,
    productCode,
    startDate,
    endDate,
    dataProviderName = "semantic",
    shouldFetchData = true,
    queryKey,
}: {
    jsonQuery?: SmlJsonQuery;
    productCode?: string;
    startDate?: string;
    endDate?: string;
    dataProviderName?: string;
    shouldFetchData?: boolean;
    queryKey?: string;
}) => {
    const apiUrl = useApiUrl(dataProviderName);
    const encodedJsonQuery = jsonQuery
        ? btoa(
              JSON.stringify({
                  filters: jsonQuery?.filters,
                  orders: jsonQuery?.orders,
                  select: jsonQuery?.select,
              }),
          )
        : undefined;

    const { data, isError, error, debouncedRefetch, isFetching } = useSmartCustomQuery({
        url: `${apiUrl}/load`,
        method: "get",

        config: {
            headers: {
                "product-code": productCode,
                "start-date": startDate,
                "end-date": endDate,
            },
            params: {
                encoded_json_query: encodedJsonQuery,
                limit: jsonQuery?.limit ?? DEFAULT_LIMIT,
            },
        },
        dataProviderName: dataProviderName,
        queryOptions: {
            queryKey: ["load", queryKey],
            retry: 3,
            enabled:
                shouldFetchData && Boolean(productCode) && Boolean(encodedJsonQuery) && encodedJsonQuery?.length === 0,
            cacheTime: 10 * 60 * 1000,
        },
    });

    return {
        isLoading: isFetching,
        isError,
        loadResponse: data,
        error,
        refetch: debouncedRefetch,
    };
};
